// @flow

import React, { Component } from "react";

import CheckboxHierarchyTree from "../../checkbox-hierarchy-tree";
import type { WidgetProps } from "@rjsf/utils";

type Props = $Exact<{ ...WidgetProps, options: Object }>;

class CheckboxHierarchyTreeWidget extends Component<Props> {
  handleChange = (selected: Array<Object>): void => {
    if (!selected) return;

    this.props.onChange(selected);
  };

  get selected() {
    if (!this.props.value) {
      return [];
    }

    return this.props.value.map(i => i.id);
  }

  get excluded() {
    if (!this.props.value) {
      return [];
    }

    return this.props.value.reduce(
      (acc, current) => (current.excluded ? [...current.excluded] : current),
      [],
    );
  }

  render() {
    return (
      <div className="schema-form-widget-checkbox-hierarchy-tree">
        <CheckboxHierarchyTree
          searchable={!!this.props.options.searchable}
          searchPlaceholder={this.props.options.searchPlaceholder}
          tree={this.props.schema.tree}
          selected={this.selected}
          excluded={this.excluded}
          disabled={false}
          onChange={this.handleChange}
          expanded={[]}
        />
      </div>
    );
  }
}

export default CheckboxHierarchyTreeWidget;
